import swal from "sweetalert2";

export const showAlert = ({
  title = "¡Registrado correctamente!",
  text = "Tu registro se ha completado con éxito.",
  icon = "success",
  confirmButtonText = "OK",
  callback,
}) => {
  swal.fire({ title, text, icon, confirmButtonText }).then(callback);
};


export const showAlertAsistencia = ({
  title = "¡Asistencia guardada!",
  text = "Asistencia guardada correctamente",
  icon = "success",
  confirmButtonText = "OK",
  callback,
}) => {
  swal.fire({ title, text, icon, confirmButtonText }).then(callback);
};

export const showAlertGrupo = ({
  title = "¡Unión de grupos exitosa!",
  text = "",
  icon = "success",
  confirmButtonText = "OK",
  callback,
}) => {
  swal.fire({ title, text, icon, confirmButtonText }).then(callback);
};

export const showErrorAlert = ({
  title = "¡Error!",
  text = "Hubo un problema.",
  icon = "error",
  confirmButtonText = "OK",
  callback,
}) => {
  swal.fire({ title, text, icon, confirmButtonText }).then(callback);
};

export const showQuestionDeleteAlert = ({
  title = "¡Alerta!",
  text = "¿Estás seguro que deseas eliminar este registro?.",
  icon = "warning",
  showCancelButton = true,
  confirmButtonColor = '#d33',
  cancelButtonColor = '#3085d6',
  confirmButtonText = 'Sí, eliminar',
  cancelButtonText = 'Cancelar',
  callback,
}) => {
  swal.fire({ title, text, icon, showCancelButton, confirmButtonColor, cancelButtonColor, confirmButtonText, cancelButtonText }).then(callback);
};

export const showDeletedAlert = ({
  title = "¡Eliminado Correctamente!",
  text = "El registro ha sido eliminado correctamente",
  icon = "success",
  confirmButtonText = "OK",
  callback,
}) => {
  swal.fire({ title, text, icon, confirmButtonText }).then(callback);
};


export const showUpdateAlert = ({ callback }) => {
  swal
    .fire({
      title: "¿Estás seguro?",
      text: "¿Quieres editar los datos?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, actualizar",
      cancelButtonText: "Cancelar",
    })
    .then((result) => {
      if (result.isConfirmed) {
        callback();  // Llama al callback (navegar a la página de actualización)
      }
    });
};

export const showActualizadoCorrectamenteAlert = (
    {
      title = "¡Actualizado correctamente!",
      text = "Los datos han sido actualizados correctamente.",
      icon = "success",
      confirmButtonText = "OK",
      callback,
    }) => {
  swal.fire({ title, text, icon, confirmButtonText }).then(callback);
};


export const showUpdateCreditoAlert = (
  {
    title = "¡El crédito ha sido restablecido a 0!",
    text = "El crédito se mantiene en 0 porque el estudiante es regular. Para modificar el crédito, cambia el tipo de admisión a Becario.",
    icon = "warning",
    confirmButtonText = "OK",
    callback,
  }) => {
swal.fire({ title, text, icon, confirmButtonText }).then(callback);
};

export const showAlertDescongelar = (
  {
    title = "El estudiante está congelado",
    text = "",
    icon = "warning",
    confirmButtonText = "OK",
    callback,
  }) => {
swal.fire({ title, text, icon, confirmButtonText }).then(callback);
};

export const showAlertEstadoConDescongelar = (
  {
    title = "Estado actualizado con éxito",
    text = "",
    icon = "warning",
    confirmButtonText = "OK",
    callback,
  }) => {
swal.fire({ title, text, icon, confirmButtonText }).then(callback);
};


export const showAlertSelectCongelacion = (
  {
    title = "Alerta: Primero debe seleccionar",
    text = "",
    icon = "warning",
    confirmButtonText = "OK",
    callback,
  }) => {
swal.fire({ title, text, icon, confirmButtonText }).then(callback);
};

export const showAlertCreditoBajo = ({
  title = "¡Atención!",
  text = "Te queda solo 1 crédito disponible. Por favor comunicarse con el número 75695564 - Administración EduServer.",
  icon = "warning",
  confirmButtonText = "Entendido",
  callback,
}) => {
  swal.fire({ title, text, icon, confirmButtonText }).then(callback);
};
